(() => {
  const overlay = document.getElementById('HpQuoteModal');
  const form = document.getElementById('HpQuoteForm');
  const msg = document.getElementById('HpQuoteMsg');
  const title = document.getElementById('HpQuoteTitle');
  const intro = document.getElementById('HpQuoteIntro');
  const successBox = document.getElementById('HpQuoteSuccess');

  if (!overlay || !form) return;

  const modalBox = overlay.querySelector('.hp-quote-modal');
  const defaultTitle = title ? title.textContent : 'Créer un devis';

  const hiddenCartToken = form.querySelector('[data-hp-quote-cart-token]');
  const hiddenCurrency = form.querySelector('[data-hp-quote-currency]');
  const hiddenTotal = form.querySelector('[data-hp-quote-total]');
  const hiddenCartSummary = form.querySelector('[data-hp-quote-cart-summary]');
  const hiddenCartJson = form.querySelector('[data-hp-quote-cart-json]');

  const QUOTE_WEBHOOK_URL = 'https://webhooks.mechanic.dev/78cfa15b-b1a4-499a-a1e6-3e567be1e12c';
  const DRAFT_STORAGE_KEY = 'hp_quote_pending_draft_v1';
  const DRAFT_SENT_PREFIX = 'hp_quote_draft_sent_v1:';

  let currentCart = null;

  const setLoading = (isLoading) => {
  if (modalBox) modalBox.classList.toggle('is-loading', !!isLoading);

  const buttons = overlay.querySelectorAll('button');
  buttons.forEach((btn) => {
    btn.disabled = !!isLoading;
  });
};

const showFormState = () => {
  if (title) title.textContent = defaultTitle;
  if (intro) intro.hidden = false;
  if (successBox) successBox.hidden = true;
  form.hidden = false;
};

const showSuccessState = () => {
  if (title) title.textContent = 'Demande envoyée';
  if (intro) intro.hidden = true;
  if (successBox) successBox.hidden = false;
  form.hidden = true;
};

  const open = () => {
  overlay.classList.add('hp-show');
  overlay.setAttribute('aria-hidden', 'false');
};

const close = () => {
  overlay.classList.remove('hp-show');
  overlay.setAttribute('aria-hidden', 'true');

  if (successBox && successBox.hidden === false) {
    window.setTimeout(() => {
      showFormState();
      form.reset();
      if (msg) msg.textContent = '';
      setLoading(false);
    }, 150);
  }
};

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format((parseInt(cents || 0, 10) || 0) / 100);
    } catch (e) {
      return ((parseInt(cents || 0, 10) || 0) / 100).toFixed(2) + ' €';
    }
  }

  function buildCartSummary(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';

    return cart.items.map((item) => {
      let label = item.product_title || item.title || 'Produit';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        label += ' - ' + item.variant_title;
      }
      return label + ' x' + item.quantity;
    }).join(' | ');
  }

function getFieldValue(name) {
  const field = form.querySelector(`[name="${name}"]`);
  return field ? (field.value || '').trim() : '';
}

function buildDraftPayload(cart) {
  return {
    customer: {
      email: getFieldValue('contact[email]'),
      first_name: getFieldValue('contact[Prénom]'),
      last_name: getFieldValue('contact[Nom]'),
      company: getFieldValue('contact[Structure / Organisme]'),
      siret: getFieldValue('contact[SIRET]'),
      vat: getFieldValue('contact[TVA intracom]'),
      phone: getFieldValue('contact[Téléphone]'),
      address1: getFieldValue('contact[Adresse principale]'),
      address2: getFieldValue('contact[Complément adresse]'),
      city: getFieldValue('contact[Ville]'),
      zip: getFieldValue('contact[Code postal]'),
      country_code: 'FR',
      note: getFieldValue('contact[body]')
    },
    cart: {
      token: cart.token || '',
      currency: cart.currency || 'EUR',
      attributes: cart.attributes || {},
      items: (cart.items || []).map((item) => ({
        variant_id: item.variant_id,
        quantity: item.quantity
      }))
    },
    quote_token: getFieldValue('contact[Quote token]'),
    quote_timestamp: getFieldValue('contact[Quote timestamp]')
  };
}

async function triggerDraftCreation(payload) {
  if (!QUOTE_WEBHOOK_URL) {
    console.warn('[HYMAPRO] QUOTE_WEBHOOK_URL manquant.');
    return;
  }

  const cartToken = (payload && payload.cart && payload.cart.token) ? payload.cart.token : 'no-cart-token';
  const sentKey = `${DRAFT_SENT_PREFIX}${cartToken}`;

  if (sessionStorage.getItem(sentKey) === '1') {
    return;
  }

  const response = await fetch(QUOTE_WEBHOOK_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload),
    keepalive: true
  });

  if (!response.ok) {
    throw new Error('Le déclenchement du brouillon de devis a échoué.');
  }

  sessionStorage.setItem(sentKey, '1');
  sessionStorage.removeItem(DRAFT_STORAGE_KEY);
}

async function prepareHiddenFields() {
  try {
    const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!cartRes.ok) return;
    const cart = await cartRes.json();
    if (!cart.items || cart.items.length === 0) return;

    currentCart = cart;

    const summary = buildCartSummary(cart);
    const payload = {
      token: cart.token || '',
      currency: cart.currency || 'EUR',
      total_price: cart.total_price || 0,
      note: cart.note || '',
      attributes: cart.attributes || {},
      items: (cart.items || []).map((item) => ({
        product_id: item.product_id,
        variant_id: item.variant_id,
        product_title: item.product_title,
        variant_title: item.variant_title,
        quantity: item.quantity,
        price: item.price
      }))
    };

    if (hiddenCartToken) hiddenCartToken.value = cart.token || '';
    if (hiddenCurrency) hiddenCurrency.value = cart.currency || 'EUR';
    if (hiddenTotal) hiddenTotal.value = formatMoney(cart.total_price || 0, cart.currency || 'EUR');
    if (hiddenCartSummary) hiddenCartSummary.value = summary;
    if (hiddenCartJson) hiddenCartJson.value = JSON.stringify(payload);
  } catch (err) {
    console.error('[HYMAPRO] prepareHiddenFields error:', err);
  }
}

function saveDraftToSession() {
  if (!currentCart) return;
  try {
    const draftPayload = buildDraftPayload(currentCart);
    const sentKey = `${DRAFT_SENT_PREFIX}${draftPayload.cart.token || 'no-cart-token'}`;
    sessionStorage.removeItem(sentKey);
    sessionStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(draftPayload));
  } catch (err) {
    console.error('[HYMAPRO] Draft payload save error:', err);
  }
}

  document.addEventListener('click', (e) => {
  const btn = e.target.closest('#HpQuoteOpen, .hp-quote-open');
  if (!btn) return;
  if (btn.hasAttribute('disabled')) return;

  document.querySelector('cart-drawer')?.close?.();

  showFormState();
  if (msg) msg.textContent = '';
  setLoading(false);
  open();
  prepareHiddenFields();
});

  overlay.addEventListener('click', (e) => {
    if (modalBox && modalBox.classList.contains('is-loading')) return;

    if (e.target === overlay) close();
    if (e.target.closest('[data-hp-quote-close]')) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (!overlay.classList.contains('hp-show')) return;
    if (modalBox && modalBox.classList.contains('is-loading')) return;
    close();
  });

form.addEventListener('submit', async (e) => {
    // Honeypot : bot détecté, on simule le succès
    if (getFieldValue('contact[website]')) {
      e.preventDefault();
      showSuccessState();
      setLoading(false);
      return;
    }

    // Fallback : hidden fields vides (submit très rapide avant fin du fetch initial)
    if (hiddenCartJson && !hiddenCartJson.value) {
      e.preventDefault();
      if (msg) msg.textContent = 'Chargement de votre panier en cours, merci de patienter…';
      setLoading(true);
      await prepareHiddenFields();
      setLoading(false);
      if (hiddenCartJson && hiddenCartJson.value) {
        saveDraftToSession();
        form.submit();
      } else {
        if (msg) msg.textContent = 'Impossible de lire le panier. Réessayez.';
      }
      return;
    }

    // Cas normal : hidden fields déjà remplis à l'ouverture du modal.
    // On sauve le draftPayload avec les infos client réellement saisies,
    // puis on laisse le form se soumettre nativement (pas de preventDefault).
    saveDraftToSession();
    if (msg) msg.textContent = 'Envoi en cours…';
    setLoading(true);
  });

  (function () {
  try {
    const url = new URL(window.location.href);
    const isPosted = url.searchParams.get('contact_posted') === 'true';
    const hasErrors = !!overlay.querySelector('.hp-quote-errors');

    if (hasErrors) {
      showFormState();
      open();
      setLoading(false);
      if (msg) msg.textContent = '';
      return;
    }

    if (!isPosted) {
      showFormState();
      return;
    }

    showSuccessState();
    open();
    setLoading(false);
    form.reset();

    const rawDraftPayload = sessionStorage.getItem(DRAFT_STORAGE_KEY);
    if (rawDraftPayload) {
      try {
        const parsedDraftPayload = JSON.parse(rawDraftPayload);
        triggerDraftCreation(parsedDraftPayload).catch((err) => {
          console.error('[HYMAPRO] Draft quote trigger error:', err);
        });
      } catch (err) {
        console.error('[HYMAPRO] Draft payload parse error:', err);
        sessionStorage.removeItem(DRAFT_STORAGE_KEY);
      }
    }

    url.searchParams.delete('contact_posted');
    url.hash = '';
    window.history.replaceState({}, '', url.pathname + url.search);
  } catch (e) {}
})();
})();